<template>
	<div class="products-list table-responsive" v-if="selectedSellers.length > 0">
		<table class="products-list-table table table-primary table-striped">
			<thead>
				<tr>
					<th>No</th>
					<th>Name</th>
					<th>Email</th>
					<th>Action</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(dropshipper, idx) in selectedSellers" :key="dropshipper.user_id">
					<td>{{ idx + 1 }}</td>
					<td>{{ dropshipper.name }}</td>
					<td>{{ dropshipper.email }}</td>
					<td class="text-center" @click="removeDropshipper(dropshipper.user_id)">
						<i class="material-icons has-tooltip cursor-pointer text-danger" v-tooltip="'Remove Seller'">
							delete
						</i>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import { duplicateVar } from '@/lib/helper';

export default {
	props: {
		selectedDropshippers: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			selectedSellers: [],
		};
	},
	watch: {
		selectedDropshippers() {
			this.selectedSellers = duplicateVar(this.selectedDropshippers);
		},
	},
	methods: {
		removeDropshipper(userId) {
			const selectedSellers = this.selectedSellers.filter(dropshipper => dropshipper.user_id !== userId);
			this.$emit('update:selected-dropshippers', selectedSellers);
		},
	},
};
</script>
